export default __webpack_public_path__ + "static/image 59-9fc1dba7d1b8c9ff4a913901c843e0fb.png";